import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import CaptainBusinessPresetsAPI from 'dashboard/api/captain/businessPresets';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: mutations => ({
    fetchBusinessPresets: async () => {
      try {
        const response = await CaptainBusinessPresetsAPI.get();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },

    // Creates the assistant and its scenarios from a business preset.
    // Resolves with { assistant, scenarios, pending_tools }.
    applyBusinessPreset: async ({ commit }, presetId) => {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await CaptainBusinessPresetsAPI.apply(presetId);
        commit(mutations.ADD, response.data.assistant);
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
        return throwErrorMessage(error);
      }
    },

    // Brings an existing assistant up to date with its business preset, keeping its FAQs,
    // documents, inboxes and settings.
    syncBusinessPreset: async ({ commit }, { presetId, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainBusinessPresetsAPI.sync(
          presetId,
          assistantId
        );
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
